"use strict";

angular.module("core").directive("fileread", function() {
    return {
        scope: {fileread: "="},
        restrict: "A",
        require: "ngModel",
        link: function(scope, element, attrs, ngModel) {
            element.bind("change", function(ChangeEvent) {
                var Reader = new FileReader();
                Reader.onload = function(LoadEvent) {
                    scope.$apply(function() {
                        ngModel.$setViewValue(LoadEvent.target.result);
                        ngModel.$render();
                    });
                };
                var NewFiles = ChangeEvent.target.files;
                if (NewFiles.length) {
                    Reader.readAsDataURL(NewFiles[0]);
                }

                var file = ChangeEvent.target.files[0];
                if (file) {
                    scope.fileread = file.name;
                    var extn = file.name.split(".").pop().toLowerCase();

                    if (attrs.validExtensions != null) {
                        const extensions = attrs.validExtensions.split(",");
                        var validExtension = false;

                        extensions.forEach(function(x) {
                            if (x.trim() === extn.trim())
                                validExtension = true;
                        });

                        ngModel.$setValidity("type", validExtension);
                    }

                    if (attrs.maxSize != null) {
                        var maxSize = attrs.maxSize;
                        var valid = (file.size / 1024) <= maxSize;

                        ngModel.$setValidity("size", valid);
                    }

                    scope.fileValidation = file ? file : undefined;
                    scope.$apply();
                }
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/fileread/fileread.directive.js
// module id = 498
// module chunks = 0